import { withSBErrorHandling } from '../types';
import { ScanbotBarcodeSDKPlugin } from './definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotImageProcessorImpl = {
    readImageData(imageFileUri) {
        return withSBErrorHandling(async () => (await ScanbotBarcodeSDKPlugin.readImageData({ imageFileUri })).result);
    },
};
//# sourceMappingURL=ImageProcessorImpl.js.map